export default "__VITE_PUBLIC_ASSET__bde1b3a5__"